export interface AuthRole {
  id: number;
  name: string;
}

export enum Roles {
  CreateTicketFundQuota = 1,
  CreateTicketPrivateFixedIncome = 2,
  CreateTicketPublicFixedIncome = 3,
  CreateTicketFutures = 4,
  CreateTicketMargin = 5,
  CreateTicketContracted = 6,
  CreateTicketCurrencyTerm = 7,
  CreateTicketVariableIncome = 8,
  CreateTicketSwapCetip = 9,

  ApprovePendingApprovalAdm = 10,
  ApprovePendingSettlementOpen = 11,
  ApproveActiveSettlementOpen = 12,
  ApprovePendingSettlementMiddle = 13,
  ApproveActiveSettlementMiddle = 14,
  ApprovePendingSettlementCustody = 15,
  ApproveActiveSettlement = 16,

  ViewApprovalHistory = 17,

  ViewMonitorFundQuota = 18,
  ViewMonitorPrivateFixedIncome = 19,
  ViewMonitorPublicFixedIncome = 20,
  ViewMonitorFutures = 21,
  ViewMonitorMargin = 22,
  ViewMonitorContracted = 23,
  ViewMonitorCurrencyTerm = 24,
  ViewMonitorVariableIncome = 25,
  ViewMonitorSwapCetip = 26,
  ApproveAccountManagerPendingTicket = 27,
  CreateMasterUser = 28,
  CreateSubordinateUser = 29,
  ChangeDefaultLimitTime = 30,
  ChangeLimitTime = 31,

  // TODO: Review IDs
  CreateTicketTransfer = 32,
  ViewMonitorTransfer = 33,
  ViewReceivable = 34,
  CreateTicketLoan = 37,
  ViewMonitorLoan = 38,
  CreateTicketExchange = 39,
  ViewMonitorExchange = 40,
  ApproveAwaitingSettlementExternalClearing = 41,
  ApproveActiveSettlementExternalClearing = 42,
  UploadTransfer = 47,
  ApproveUploadTransfer = 48,
  ViewUploadTransferMonitor = 49,

  CreateExpensesTicket = 50,
  ViewExpensesMonitor = 51,

  CreateTicketStructuredOperations = 52,
  ViewMonitorOperationStructured = 53,
  ApproveInPreAnalysis = 54,
  ApproveInAnalysis = 55,
  CreateLiabilitiesTicket = 56,
  ViewLiabilitiesMonitor = 57,
  ApproveInAnalysisReservation = 58,
  GestorCreateTicket = 59,
  AdminCreateLoad = 60,

  CreateStructuredOperationOrderTicket = 61,
  ViewStructuredOperationOrderMonitor = 62,
  ApproveInAnalysisOpinion = 63,
  ApproveInPreAnalysisOpinion = 64,
  CreateDistributorUser = 65,
  ApproveInFinalReviewerDecision = 66,
  CreateCounterpart = 67,
  ViewCountarpart = 68,
  ApproveControllershipPending = 69,

  SendBatchEmail = 70,
  RegisterBank = 71,
}
// Roles.UploadTransfer, 47
// Roles.ApproveUploadTransfer,48
// Roles.ViewUploadTransferMonitor 49
// CreateTicketVariableIncome 8
